<template>
    <div class="sign-in">
        <div class="sign-in__left">
            <img width="auto" height="33" :src="defaultLogoSrc" alt="MyCamper" />
            <span class="sign-in__rent-note">{{ $t('modals.login.rent_note') }}</span>
        </div>
        <div class="sign-in__right">
            <h2 v-if="!displayForgotPasswordForm" class="sign-in__title">
                {{ $t('modals.login.heading') }}
            </h2>

            <Notice v-if="status" class="sign-in__notice" type="success">
                <template v-if="status === 'email-verified'">
                    {{ $t('modals.login.email_has_been_verified_notice') }}
                </template>
                <template v-if="status === 'password-reset'">
                    {{ $t('modals.login.password_has_been_updated') }}
                </template>
            </Notice>

            <Notice v-if="showJwtNotice" class="sign-in__notice" type="warning">
                {{ $t('pages.login.jwt_error_notice') }}
            </Notice>

            <ForgotPasswordForm v-if="displayForgotPasswordForm" :page="page" @close-modal="toggleForgotPasswordForm" />
            <LoginForm
                v-else
                :email="email"
                @logged-in="handleLoggedIn"
                @toggle-forgot-password="toggleForgotPasswordForm"
            />

            <template v-if="!displayForgotPasswordForm">
                <div class="sign-in__divider">
                    {{ $t('modals.login.divider_between_login_options') }}
                </div>

                <SocialAuthButtons :error-redirect-to="errorRedirectTo" />

                <div class="sign-in__no-account-link">
                    {{ $t('modals.login.no_account') }}
                    <ModalLink to="sign-up">
                        {{ $t('modals.login.signup_link') }}
                    </ModalLink>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LoginForm from '~/components/onboarding/LoginForm.vue';
import ModalLink from '~/components/modals/ModalLink.vue';
import SocialAuthButtons from '~/components/onboarding/SocialAuthButtons';
import Notice from '~/components/Notice.vue';
import ForgotPasswordForm from '~/components/onboarding/ForgotPasswordForm.vue';

import defaultLogoSrc from '~/assets/images/mycamper-logo-with-text.svg';

export default {
    components: {
        SocialAuthButtons,
        LoginForm,
        Notice,
        ModalLink,
        ForgotPasswordForm,
    },
    props: {
        data: {
            type: Object,
            default: null,
        },
        page: {
            type: String,
            default: '',
        },
        showJwtNotice: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            status: this.$route.query.status,
            email: this.data?.email,
            defaultLogoSrc,
            displayForgotPasswordForm: false,
        };
    },
    computed: {
        ...mapGetters(['favoredAsset']),
        errorRedirectTo() {
            return !this.page ? { name: this.getRouteBaseName(), query: { ...this.$route.query, popup: 'login' } } : {};
        },
    },
    methods: {
        handleLoggedIn() {
            this.$emit('confirmed');
        },
        toggleForgotPasswordForm() {
            this.displayForgotPasswordForm = !this.displayForgotPasswordForm;
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/blocks/_sign-in.scss';
</style>
